import React from "react";
import YoutubePlayer from "../Player/YoutubePlayer";
import { getYoutubeEmbedUrl } from "@/utils/youtube";
import dynamic from "next/dynamic";
const Modal = dynamic(() => import("antd/es/modal"), { ssr: false });

export default function VideoStoryModal({
  modalOpen,
  closeModal,
  currentVideoLink,
}) {
  return (
    <Modal
      open={modalOpen}
      onCancel={closeModal}
      footer={null}
      width={800}
      className="video-modal"
      centered
      destroyOnHidden
    >
      <div className="video-wrapper aspect-w-16 aspect-h-9">
        <YoutubePlayer url={modalOpen ? currentVideoLink : null} />
      </div>
    </Modal>
  );
}
